module.exports = __webpack_public_path__ + "img/noAdd.37cd7b41.png";